import { Inject, Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  Router,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PrivateDomainGuard implements CanActivate {
  constructor(
    @Inject('hostUrl') private hostUrl: string,
    private readonly router: Router,
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (route.data['hosts'].includes(this.hostUrl)) {
      return this.router.parseUrl('private-domain/page-not-found');
    }
    return true;
  }
}
